import styled from 'styled-components'
import { theme } from '@dasa-health/components-react'

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    height: 100vh;
`

export const ContentContainer = styled.div`
    align-items: center;
    flex-direction: column;
    display: flex;
    width: 100vw;
    height: 80vh;

    button {
        margin: auto;
        width: 80vw;
        justify-self: flex-end;
        margin-top: 35px;
    }

    @media (min-device-width: 800px) {
        padding-top: 100px;
        height: 90vh;

        button {
            height: 48px;
            width: 496px;
        }
    }
`

export const Title = styled.h1`
    font-family: 'Dasa Sans', 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 600;
    text-align: center;
`

export const TitleContainer = styled.div`
    margin: auto;

    @media screen and (max-device-width: 800px) {
        width: 396px;
    }

    @media (min-width: 1024px) {
        width: 496px;
    }
`

export const SubTitle = styled.h2`
    color: ${theme.colors.black};
    font-family: 'Dasa Sans', 'Montserrat', sans-serif;
    font-size: ${theme.fontSizes[1]};
    font-weight: ${theme.fontWeights.normal};
    line-height: 24px;
    padding-top: 2vh;
    text-align: center;
`

export const ImageCentral = styled.img`
    padding-top: 5vh;
    height: 30vh;

    @media screen and (min-width: 1024px) {
        width: 10vw;
    }
`

export const ImageDownload = styled.img`
    height: 7vh;
    margin-top: 5vh;

    @media screen and (min-width: 1024px) {
        height: 50px;
        width: 120px;
    }
`

export const ImageHeader = styled.img`
    align-self: flex-start;
    height: 10vh;
`

export const Header = styled.header`
    align-content: flex-start;
    display: flex;
    height: 5vh;
    width: 100vw;
`

export const ImagesContainerStore = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: auto;
    width: 20vw;
`
